<template>
    <div class="main-content">
        <!-- 用户信息卡片 -->
        <el-card class="user-info-card" shadow="hover" :background-color="'#1e293b'">
            <div class="user-info-wrapper">
                <div class="user-avatar-section">
                    <!-- 使用 ElementUI 上传组件 + 头像组件 -->
                    <el-upload class="avatar-uploader" action="#" :show-file-list="false"
                        :before-upload="beforeAvatarUpload" :http-request="handleAvatarUpload" accept="*/*">
                        <el-avatar :size="100" class="user-avatar">
                            <img :src="userInfo.userAvatar || 'http://49.232.163.2:5159/image/30.png'" alt="用户头像"
                                class="avatar-img">
                            <i class="el-icon-plus avatar-uploader-icon" slot="icon"></i>
                        </el-avatar>
                    </el-upload>

                    <div class="user-base-info">
                        <div class="user-name-role">
                            <div class="name-display">
                                <h3 class="user-name">{{ userInfo.userName || '未设置昵称' }}</h3>
                                <i class="el-icon-edit name-edit-icon" @click="openEditDialog"></i>
                            </div>
                        </div>
                        <p class="user-memorial">
                            {{ userInfo.briefIntroduction || '暂无简介' }}
                        </p>
                    </div>
                </div>

                <!-- 买家统计数据 -->
                <div class="user-stats">
                    <el-statistic class="stat-item" value="1" label="待付款"
                        :value-style="{ color: '#ef4444' }"></el-statistic>
                    <el-statistic class="stat-item" value="0" label="购物车"
                        :value-style="{ color: '#f59e0b' }"></el-statistic>
                    <el-statistic class="stat-item" value="0.00" :precision="2" label="账户余额"
                        :value-style="{ color: '#10b981' }"></el-statistic>
                    <!-- <el-button type="warning" icon="el-icon-refresh-left">充值</el-button> -->
                </div>
            </div>
        </el-card>
        <el-dialog title="修改个人信息" :visible.sync="editDialogVisible" width="400px" :close-on-click-modal="false"
            @close="cancelEditDialog">
            <el-form :model="editForm" label-width="80px" ref="editFormRef">
                <el-form-item label="用户名" prop="userName">
                    <el-input v-model="editForm.userName" placeholder="请输入用户名" style="background: #000;"></el-input>
                </el-form-item>
                <el-form-item label="个人简介" prop="introduction">
                    <el-input v-model="editForm.introduction" type="textarea" :rows="4"
                        placeholder="请输入个人简介（选填）"></el-input>
                </el-form-item>
            </el-form>
            <template v-slot:footer>
                <el-button @click="cancelEditDialog">取消</el-button>
                <el-button type="primary" @click="submitEditForm" :loading="nameUpdating">保存</el-button>
            </template>
        </el-dialog>
        <!-- 我的足迹模块 -->
        <el-card class="content-card" shadow="hover" :background-color="'#1e293b'" style="border: none;">
            <span class="card-title">我的足迹</span>
            <!-- 有数据时显示列表 -->
            <div class="history-grid" v-if="historyList.length > 0">
                <div class="history-item" v-for="(item, index) in historyList" :key="index"
                    @click="goToDetail(item.modelId)">
                    <el-tooltip :content="item.title" placement="top">
                        <div class="history-img-container">
                            <img :src="item.previewUrl" :alt="item.title" class="history-img">
                        </div>
                    </el-tooltip>
                    <p class="history-name">{{ item.title }}</p>
                    <div class="history-actions">
                        <!-- <el-button size="mini" type="text" icon="el-icon-download">下载</el-button> -->
                        <!-- <el-button size="mini" type="text" icon="el-icon-star-off">收藏</el-button> -->
                    </div>
                </div>
            </div>
            <!-- 无数据时显示占位图 -->
            <div class="empty-placeholder" v-else>
                <div class="empty-icon">
                    <i class="el-icon-time"></i>
                </div>
                <div class="empty-text">暂无浏览足迹</div>
                <div class="empty-desc">快去探索精彩的3D模型世界吧～</div>
                <el-button type="primary" size="mini" @click="$router.push('/')">去逛逛</el-button>
            </div>
        </el-card>

        <!-- 猜你喜欢模块 -->
        <el-card class="content-card" shadow="hover">
            <span class="card-title">猜你喜欢</span>
            <!-- 有数据时显示列表 -->
            <div class="recommend-grid" v-if="recommendList.length > 0">
                <el-card class="recommend-card" shadow="hover" v-for="(item, index) in recommendList" :key="index">
                    <div class="recommend-img-container">
                        <img :src="item.img" :alt="item.name" class="recommend-img">
                        <div v-if="item.tag" class="recommend-tag">{{ item.tag }}</div>
                    </div>
                    <div class="recommend-info">
                        <h4 class="recommend-name">{{ item.name }}</h4>
                        <div class="recommend-meta">
                            <span class="recommend-author">{{ item.author }}</span>
                            <span class="recommend-downloads">{{ item.downloads }} 下载</span>
                        </div>
                        <div class="recommend-price">
                            <span v-if="item.free" class="free">免费</span>
                            <span v-else class="paid">{{ item.price }}云币</span>
                        </div>
                    </div>
                </el-card>
            </div>
            <!-- 无数据时显示占位图 -->
            <div class="empty-placeholder" v-else>
                <div class="empty-icon">
                    <i class="el-icon-s-data"></i>
                </div>
                <div class="empty-text">暂无推荐内容</div>
                <div class="empty-desc">系统将根据您的浏览习惯为您推荐合适的模型</div>
                <el-button type="primary" size="mini" @click="refreshRecommend">刷新推荐</el-button>
            </div>
        </el-card>
    </div>
</template>

<script>
// 引入外部组件（需确保路径与项目实际路径一致）
import Top from '../../../components/Header.vue';
import Bottom from '../../../components/Footer.vue';

export default {
    name: 'BuyerHome',
    components: { Top, Bottom },
    data() {
        return {
            // 我的足迹数据列表
            historyList: [],
            // 猜你喜欢数据列表
            recommendList: [],
            userInfo: {},
            // 头像上传加载状态
            avatarUploading: false,
            // 用户名更新请求状态
            nameUpdating: false,

            // 新增弹窗相关数据
            editDialogVisible: false, // 弹窗显示状态
            editForm: { // 编辑表单数据
                userName: '', // 用户名
                introduction: '' // 简介
            }
        };
    },
    mounted() {
        //查看我的足迹
        this.getMyFootprints();
        this.BuyerUserHomepage();
    },
    methods: {
        goToDetail(modelId) {
            const routeInfo = this.$router.resolve({
                path: '/detail',
                query: {
                    id: modelId
                }
            });
            window.open(routeInfo.href, '_blank');
        },
        getMyFootprints() {
            this.$apiFun.getMyFootprints({
                type: 1
            })
                .then(res => {
                    if (res.status == 200) {
                        //只显示最新的14条足迹
                        this.historyList = res.obj.slice(-14);
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch(error => {
                    console.error('获取足迹失败:', error);
                    this.$message.error('获取足迹数据异常');
                });
        },
        // 菜单切换：跳转至买家其他功能页
        handleMenuSelect(key) {
            switch (key) {
                case 'buyer-orders':
                    this.$router.push('/buyer/orders'); // 跳转至"我的订单"页（需配置对应路由）
                    break;
                case 'buyer-cart':
                    this.$router.push('/buyer/cart'); // 跳转至"我的购物车"页（需配置对应路由）
                    break;
                case 'buyer-recharge':
                    this.$router.push('/buyer/recharge'); // 跳转至"充值中心"页（需配置对应路由）
                    break;
                case 'buyer-history':
                    this.$router.push('/buyer/history'); // 跳转至"我的足迹"页（需配置对应路由）
                    break;
                default:
                    break;
            }
        },
        // 切换至卖家中心
        switchToSeller() {
            this.$router.push('/seller/home'); // 跳转至卖家首页（需配置对应路由）
        },
        // 刷新"猜你喜欢"内容（可扩展接口请求逻辑）
        refreshRecommend() {
            this.$message.success('已为您更新推荐内容');
            // 实际项目中可在此处添加接口请求，更新recommendList数据
        },
        // 获取用户主页信息
        BuyerUserHomepage() {
            this.$apiFun.getBuyerUserHomepage()
                .then(res => {
                    if (res.status === 200) {
                        this.userInfo = res.obj;
                    }
                })
                .catch(err => {
                    console.error('买家信息加载失败:', err);
                    this.$message?.error('买家信息加载失败，请稍后重试');
                });
        },
        // ========== ElementUI 头像上传功能 ==========
        // 上传前校验
        beforeAvatarUpload(file) {
            // 限制文件大小为5MB，开放所有格式
            const isLt5M = file.size / 1024 / 1024 < 5;

            if (!isLt5M) {
                this.$message.error('头像文件大小不能超过5MB!');
                return false;
            }

            return true;
        },
        // 自定义上传逻辑
        handleAvatarUpload(options) {
            const file = options.file;
            this.avatarUploading = true;

            // 创建FormData对象
            const formData = new FormData();
            formData.append('file', file);
            // 如果需要传递用户ID，可在此添加
            if (this.userInfo.userId) {
                formData.append('userId', this.userInfo.userId);
            }

            // 调用上传头像接口
            this.$apiFun.postUploadAvatar(formData)
                .then(res => {
                    if (res.status === 200 || res.code === 200) {
                        // 上传成功，更新用户头像
                        this.userInfo.userAvatar = res.obj || res.data;
                        this.$message.success('头像上传成功！');
                    } else {
                        this.$message.error('头像上传失败：' + (res.msg || '服务器错误'));
                    }
                })
                .catch(err => {
                    console.error('头像上传失败:', err);
                    this.$message.error('头像上传失败，请稍后重试');
                })
                .finally(() => {
                    this.avatarUploading = false;
                });
        },

        // ========== 用户名编辑功能 ==========
        // 打开编辑弹窗
        openEditDialog() {
            // 初始化表单数据
            this.editForm.userName = this.userInfo.userName || '';
            this.editForm.introduction = this.userInfo.briefIntroduction || '';
            this.editDialogVisible = true;
        },

        // 取消编辑弹窗
        cancelEditDialog() {
            this.editDialogVisible = false;
            // 重置表单
            this.$refs.editFormRef?.resetFields();
        },

        // 提交编辑表单
        submitEditForm() {
            // 简单校验用户名
            if (!this.editForm.userName.trim()) {
                this.$message.warning('用户名不能为空！');
                return;
            }

            // 用户名未变化且简介也未变化时直接关闭弹窗
            const isNameSame = this.editForm.userName.trim() === (this.userInfo.userName || '');
            const isIntroSame = this.editForm.introduction === (this.userInfo.briefIntroduction || '');
            if (isNameSame && isIntroSame) {
                this.cancelEditDialog();
                return;
            }

            this.nameUpdating = true;

            // 调用修改接口，新增Introduction参数
            this.$apiFun.postPersonalnform({
                UserName: this.editForm.userName.trim(),
                Introduction: this.editForm.introduction || '' // 新增简介参数
            })
                .then(res => {
                    if (res.status == 200) {
                        // 更新本地用户信息
                        this.userInfo.userName = this.editForm.userName.trim();
                        this.userInfo.briefIntroduction = this.editForm.introduction || '';
                        this.$message.success('信息修改成功！');
                        this.editDialogVisible = false;
                    } else {
                        this.$message.error(`修改失败：${res.message || '服务器错误'}`);
                    }
                })
                .catch(err => {
                    console.error('修改信息失败:', err);
                    this.$message.error('修改信息失败，请稍后重试');
                })
                .finally(() => {
                    this.nameUpdating = false;
                });
        },

        // 模拟改名接口
        updateUserNameApi(newName) {
            // 返回Promise模拟异步接口调用
            return new Promise((resolve) => {
                // 模拟接口延迟
                setTimeout(() => {
                    // 模拟接口成功返回
                    resolve({
                        success: true,
                        message: '用户名修改成功'
                    });

                    // 如需测试失败场景，可注释上面的resolve，启用下面的
                    // resolve({
                    //     success: false,
                    //     message: '用户名已存在'
                    // });
                }, 800);
            });
        }
    }
};
</script>

<style lang="less" scoped>
// 深色主题基础配色
@bg-primary: #0f1118;
@text-primary: #e2e8f0;
@text-secondary: #a0aec0;
@accent-blue: #38bdf8;
@accent-red: #ef4444;
@accent-green: #10b981;
@accent-yellow: #f59e0b;
@card-bg: #1e293b;
@border-color: #4a5568;

// 页面容器基础样式 - 移除固定最小宽度，优化溢出
.buyer-home-page {
    min-height: 100vh;
    background-color: @bg-primary;
    color: @text-primary;
    display: flex;
    flex-direction: column;
    width: 100%;
    // 移除固定最小宽度，解决小屏溢出
    // min-width: 1905px; 
    margin: 0 auto;
    box-sizing: border-box;
    overflow-x: hidden; // 防止页面整体横向溢出
}

// 主内容区布局（侧边栏+内容区）
.dashboard-container {
    display: flex;
    flex: 1;
    gap: 15px;
    height: calc(100vh - 130px); // 减去顶部导航和底部版权高度
    overflow: hidden;
    width: 100%;
    box-sizing: border-box;
    padding: 0 10px;

    // 响应式：小屏时侧边栏折叠/垂直排列
    @media screen and (max-width: 992px) {
        flex-direction: column;
        height: auto;
        min-height: calc(100vh - 130px);
    }
}

// 左侧侧边栏样式
.sidebar {
    width: 220px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    height: 100%;
    background-color: #080a12;
    box-sizing: border-box;

    // 响应式：小屏时侧边栏占满宽度
    @media screen and (max-width: 992px) {
        width: 100%;
        height: auto;
        margin-bottom: 15px;
    }

    // 角色切换选项卡
    .role-tabs {
        display: flex;
        border-bottom: 1px solid @border-color;

        .role-btn {
            flex: 1;
            padding: 12px 0;
            background: #1a202c;
            border: none;
            color: @text-secondary;
            font-size: 16px;
            cursor: pointer;
            transition: all 0.3s;
            box-sizing: border-box;

            &.active {
                background: @card-bg;
                color: @accent-blue;
            }

            &:hover {
                background: #2d3748;
            }
        }
    }

    // 买家导航菜单
    .nav-menu {
        border-radius: 4px;
        height: calc(100% - 50px); // 减去角色选项卡高度
        border-right: none;
        overflow-y: auto;

        // 响应式：小屏时菜单高度自适应
        @media screen and (max-width: 992px) {
            height: auto;
            max-height: 300px;
        }

        // 滚动条样式优化
        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background-color: rgba(56, 189, 248, 0.3);
            border-radius: 3px;
        }

        &::-webkit-scrollbar-track {
            background-color: transparent;
        }
    }
}

// 右侧主内容区域样式
.main-content {
    flex: 1;
    overflow-y: auto;
    padding: 5px;
    box-sizing: border-box;
    width: 100%; // 确保占满容器

    // 页面标题（如"买家中心"）
    .page-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
        flex-wrap: wrap; // 小屏时换行

        .page-title {
            font-size: 20px;
            color: @text-primary;
            margin: 0;

            @media screen and (max-width: 768px) {
                font-size: 18px;
                width: 100%;
                margin-bottom: 10px;
            }
        }
    }

    // 用户信息卡片（头像、昵称、统计数据）
    .user-info-card {
        margin-bottom: 15px;
        background: #080a12;
        border: none;
        box-sizing: border-box;
        width: 100%;

        .user-info-wrapper {
            display: flex;
            flex-wrap: wrap; // 替换nowrap，允许换行
            gap: 20px;
            align-items: center;
            padding: 15px;

            // 响应式：小屏时垂直排列
            @media screen and (max-width: 768px) {
                flex-direction: column;
                align-items: flex-start;
                gap: 15px;
            }

            .user-avatar-section {
                display: flex;
                align-items: center;
                gap: 15px;
                flex: 1;
                min-width: 280px; // 最小宽度保证布局可用

                // 响应式：小屏时调整布局
                @media screen and (max-width: 576px) {
                    flex-direction: column;
                    align-items: flex-start;
                    gap: 10px;
                }

                // ElementUI 上传组件样式
                .avatar-uploader {
                    width: 100px;
                    height: 100px;
                    flex-shrink: 0; // 禁止收缩

                    @media screen and (max-width: 576px) {
                        width: 80px;
                        height: 80px;
                    }

                    ::v-deep .el-upload {
                        width: 100%;
                        height: 100%;
                    }

                    // ElementUI 头像组件样式
                    .user-avatar {
                        width: 100%;
                        height: 100%;
                        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                        cursor: pointer;
                        margin-left: 0;

                        // 头像图片居中显示
                        .avatar-img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            object-position: center center;
                        }

                        // 上传图标样式
                        .avatar-uploader-icon {
                            font-size: 28px;
                            color: #8c939d;
                            width: 100%;
                            height: 100%;
                            line-height: 100px;
                            text-align: center;
                            background-color: #f5f7fa;
                            border-radius: 10%;

                            @media screen and (max-width: 576px) {
                                font-size: 24px;
                                line-height: 80px;
                            }
                        }
                    }

                    // 悬停效果
                    ::v-deep .el-upload:hover {
                        .user-avatar {
                            box-shadow: 0 0 10px rgba(56, 189, 248, 0.5);
                        }
                    }
                }

                .user-base-info {
                    flex: 1;
                    min-width: 180px;

                    .user-name-role {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        margin-bottom: 8px;
                        flex-wrap: wrap;

                        .user-name {
                            font-size: 18px;
                            margin: 0;
                            color: #fff;

                            @media screen and (max-width: 576px) {
                                font-size: 16px;
                            }
                        }

                        // 用户名显示区域样式
                        .name-display {
                            display: flex;
                            align-items: center;
                            gap: 8px;

                            .name-edit-icon {
                                color: @text-secondary;
                                font-size: 14px;
                                cursor: pointer;
                                transition: color 0.2s;

                                &:hover {
                                    color: @accent-blue;
                                }
                            }
                        }

                        // 用户名编辑区域样式
                        .name-edit {
                            display: flex;
                            align-items: center;
                            gap: 8px;
                            width: 100%;

                            .name-input {
                                flex: 1;
                                max-width: 200px;

                                ::v-deep .el-input__inner {
                                    background-color: #2d3748;
                                    border-color: @border-color;
                                    color: #fff;
                                }
                            }
                        }
                    }

                    .user-memorial {
                        font-size: 13px;
                        color: @text-secondary;
                        line-height: 1.6;
                        margin: 0 0 10px 0;
                        width: 100%;
                        word-break: break-word; // 防止长文本溢出
                    }

                    .user-actions {
                        display: flex;
                        gap: 10px;
                        flex-wrap: wrap; // 小屏时按钮换行
                    }
                }
            }

            // 买家统计数据（待付款、购物车、余额）
            .user-stats {
                display: flex;
                align-items: center;
                gap: 20px;
                min-width: 280px; // 最小宽度
                flex-shrink: 0;

                // 响应式：小屏时调整间距和大小
                @media screen and (max-width: 768px) {
                    width: 100%;
                    justify-content: space-around;
                    gap: 10px;
                }

                @media screen and (max-width: 576px) {
                    justify-content: space-between;
                    gap: 5px;
                }

                .stat-item {
                    text-align: center;
                    min-width: 80px;

                    @media screen and (max-width: 576px) {
                        min-width: 60px;
                    }

                    .el-statistic__label {
                        color: @text-secondary;
                        font-size: 13px;
                        margin-top: 5px;

                        @media screen and (max-width: 576px) {
                            font-size: 12px;
                        }
                    }

                    .el-statistic__content {
                        font-size: 16px;

                        @media screen and (max-width: 576px) {
                            font-size: 14px;
                        }
                    }
                }
            }
        }
    }

    // 内容卡片通用样式（足迹、推荐）
    .content-card {
        color: #fff;
        margin-bottom: 15px;
        background: #080a12;
        border: none;
        box-sizing: border-box;
        width: 100%;

        .card-title {
            font-size: 16px;
            font-weight: 500;
            display: block;
            margin-bottom: 15px;
            padding-top: 10px;
            padding-left: 10px;

            @media screen and (max-width: 576px) {
                font-size: 15px;
                padding-left: 5px;
            }
        }

        // 空内容占位样式
        .empty-placeholder {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 60px 20px;
            color: @text-secondary;
            background-color: rgba(30, 41, 59, 0.3);
            border-radius: 8px;
            margin: 0 10px 15px;
            width: calc(100% - 20px); // 防止溢出

            @media screen and (max-width: 768px) {
                padding: 40px 15px;
                margin: 0 5px 15px;
                width: calc(100% - 10px);
            }

            @media screen and (max-width: 576px) {
                padding: 30px 10px;
            }

            .empty-icon {
                font-size: 48px;
                color: rgba(160, 174, 192, 0.3);
                margin-bottom: 16px;

                @media screen and (max-width: 576px) {
                    font-size: 36px;
                    margin-bottom: 12px;
                }
            }

            .empty-text {
                font-size: 16px;
                color: @text-primary;
                margin-bottom: 8px;

                @media screen and (max-width: 576px) {
                    font-size: 14px;
                }
            }

            .empty-desc {
                font-size: 14px;
                color: @text-secondary;
                margin-bottom: 20px;
                text-align: center;
                line-height: 1.5;

                @media screen and (max-width: 576px) {
                    font-size: 13px;
                    margin-bottom: 15px;
                }
            }
        }
    }

    // 我的足迹模块样式
    .history-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)); // 减小最小宽度
        gap: 15px;
        padding: 5px 10px 15px;
        width: 100%;
        box-sizing: border-box;

        // 响应式：小屏时调整列数和间距
        @media screen and (max-width: 768px) {
            grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
            gap: 10px;
            padding: 5px 5px 15px;
        }

        @media screen and (max-width: 576px) {
            grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
            gap: 8px;
        }

        .history-item {
            display: flex;
            flex-direction: column;
            gap: 8px;
            background-color: @card-bg;
            border-radius: 4px;
            padding: 10px;
            transition: transform 0.2s;
            cursor: pointer;
            box-sizing: border-box;

            &:hover {
                transform: translateY(-3px);
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
            }

            .history-img-container {
                width: 100%;
                height: 130px;
                border-radius: 4px;
                overflow: hidden;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

                @media screen and (max-width: 768px) {
                    height: 110px;
                }

                @media screen and (max-width: 576px) {
                    height: 90px;
                }

                .history-img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: transform 0.3s;

                    &:hover {
                        transform: scale(1.05);
                    }
                }
            }

            .history-name {
                font-size: 14px;
                color: @text-primary;
                margin: 0;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                padding: 0 5px;

                @media screen and (max-width: 576px) {
                    font-size: 12px;
                }
            }

            .history-actions {
                display: flex;
                justify-content: space-between;
                padding: 0 5px;

                .el-button {
                    color: @text-secondary;
                    padding: 0;
                    height: auto;
                    font-size: 12px;

                    &:hover {
                        color: @accent-blue;
                    }
                }
            }
        }
    }

    // 猜你喜欢模块样式
    .recommend-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(240px, 1fr)); // 减小最小宽度
        gap: 15px;
        padding: 5px 10px 15px;
        width: 100%;
        box-sizing: border-box;

        // 响应式：小屏时调整列数和间距
        @media screen and (max-width: 992px) {
            grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
        }

        @media screen and (max-width: 768px) {
            grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
            gap: 10px;
            padding: 5px 5px 15px;
        }

        @media screen and (max-width: 576px) {
            grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
            gap: 8px;
        }

        .recommend-card {
            background: @card-bg;
            border: none;
            overflow: hidden;
            transition: transform 0.3s;
            width: 100%;
            box-sizing: border-box;

            &:hover {
                transform: translateY(-3px);
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
            }

            .recommend-img-container {
                position: relative;
                height: 180px;
                overflow: hidden;

                @media screen and (max-width: 992px) {
                    height: 150px;
                }

                @media screen and (max-width: 768px) {
                    height: 120px;
                }

                @media screen and (max-width: 576px) {
                    height: 100px;
                }

                .recommend-img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: transform 0.3s;

                    &:hover {
                        transform: scale(1.05);
                    }
                }

                .recommend-tag {
                    position: absolute;
                    top: 8px;
                    right: 8px;
                    background-color: rgba(56, 189, 248, 0.2);
                    color: @accent-blue;
                    font-size: 12px;
                    padding: 2px 8px;
                    border-radius: 4px;
                    z-index: 1;

                    @media screen and (max-width: 576px) {
                        font-size: 10px;
                        padding: 1px 6px;
                        top: 4px;
                        right: 4px;
                    }
                }
            }

            .recommend-info {
                padding: 10px;

                .recommend-name {
                    color: #fff;
                    font-size: 15px;
                    margin: 0 0 8px 0;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    height: 36px;

                    @media screen and (max-width: 768px) {
                        font-size: 14px;
                        height: 32px;
                    }

                    @media screen and (max-width: 576px) {
                        font-size: 12px;
                        height: 28px;
                        margin-bottom: 5px;
                    }
                }

                .recommend-meta {
                    display: flex;
                    justify-content: space-between;
                    font-size: 12px;
                    color: @text-secondary;
                    margin-bottom: 8px;
                    flex-wrap: wrap;
                    gap: 5px;

                    @media screen and (max-width: 576px) {
                        font-size: 11px;
                        margin-bottom: 5px;
                        flex-direction: column;
                        gap: 2px;
                    }
                }

                .recommend-price {
                    .free {
                        color: @accent-green;
                        font-weight: 500;
                        font-size: 14px;
                    }

                    .paid {
                        color: @accent-red;
                        font-weight: 500;
                        font-size: 14px;
                    }

                    @media screen and (max-width: 576px) {
                        font-size: 12px;
                    }
                }
            }
        }
    }
}

// Element组件样式适配（深色主题）
::v-deep .el-card__header {
    border-bottom: 1px solid transparent;
    padding: 15px 15px 10px;
    box-sizing: border-box;
}

::v-deep .el-card__body {
    padding: 15px;
    box-sizing: border-box;
    width: 100%;
}

::v-deep .el-menu {
    width: 100%;
    box-sizing: border-box;

    .el-submenu__title,
    .el-menu-item {
        color: @text-secondary;
        transition: all 0.2s;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        &:hover {
            color: @accent-blue;
            background-color: rgba(56, 189, 248, 0.1);
        }
    }

    .el-menu-item.is-active {
        color: @accent-blue;
        background-color: rgba(56, 189, 248, 0.1);
    }
}

::v-deep .el-tag--info {
    background-color: rgba(56, 189, 248, 0.2);
    border-color: @accent-blue;
    color: @accent-blue;
}

::v-deep .el-tooltip__popper {
    background-color: #1a202c;
    border-color: @border-color;
    color: @text-primary;
    max-width: 200px; // 限制tooltip宽度
    box-sizing: border-box;
}

::v-deep .el-button--primary {
    background-color: @accent-blue;
    border-color: @accent-blue;
    padding: 8px 16px;

    &:hover {
        background-color: #25a5e7;
        border-color: #25a5e7;
    }

    @media screen and (max-width: 576px) {
        padding: 6px 12px;
        font-size: 12px;
    }
}

::v-deep .el-button--success {
    background-color: @accent-green;
    border-color: @accent-green;

    &:hover {
        background-color: #0e9f7a;
        border-color: #0e9f7a;
    }
}

::v-deep .el-button--warning {
    background-color: @accent-yellow;
    border-color: @accent-yellow;

    &:hover {
        background-color: #d97706;
        border-color: #d97706;
    }
}

// 强制ElementUI头像组件居中显示
::v-deep .el-avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10%;

    img {
        object-fit: cover !important;
        object-position: center center !important;
        border-radius: 10%;
    }
}

// 全局响应式断点补充
// 大屏适配
@media screen and (min-width: 1400px) {
    .main-content {
        padding: 10px;
    }

    .history-grid {
        grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    }

    .recommend-grid {
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    }
}

// 超小屏适配（480px以下）
@media screen and (max-width: 480px) {
    .history-grid {
        grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    }

    .recommend-grid {
        grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    }

    .user-stats {
        .stat-item {
            min-width: 50px;
        }
    }
}

// ========== 新增暗色系弹窗样式 ==========
::v-deep .el-dialog {
    // 弹窗外层容器
    background-color: #1e293b;
    border: 1px solid #4a5568;
    border-radius: 8px;
}

::v-deep .el-dialog__header {
    // 弹窗头部
    border-bottom: 1px solid #4a5568;
    padding: 15px 20px;

    .el-dialog__title {
        // 弹窗标题
        color: #e2e8f0;
        font-size: 16px;
        font-weight: 500;
    }

    .el-dialog__headerbtn .el-dialog__close {
        // 关闭按钮
        color: #a0aec0;
        font-size: 18px;

        &:hover {
            color: #38bdf8;
            background-color: rgba(56, 189, 248, 0.1);
        }
    }
}

::v-deep .el-dialog__body {
    // 弹窗内容区
    padding: 20px;
    color: #e2e8f0;

    // 表单样式适配
    .el-form {
        .el-form-item {
            margin-bottom: 20px;

            .el-form-item__label {
                // 表单标签
                color: #a0aec0;
                font-size: 14px;
            }

            .el-input {

                // 输入框样式
                ::v-deep .el-input__inner {
                    background-color: #0f172a;
                    border: 1px solid #4a5568;
                    color: #e2e8f0;
                    border-radius: 4px;

                    &:focus {
                        border-color: #38bdf8;
                        box-shadow: 0 0 0 2px rgba(56, 189, 248, 0.2);
                    }

                    &::placeholder {
                        color: #64748b;
                    }
                }

                // 文本域样式
                &.el-textarea {
                    ::v-deep .el-textarea__inner {
                        background-color: #0f172a;
                        border: 1px solid #4a5568;
                        color: #e2e8f0;
                        line-height: 1.5;

                        &:focus {
                            border-color: #38bdf8;
                            box-shadow: 0 0 0 2px rgba(56, 189, 248, 0.2);
                        }
                    }
                }
            }
        }
    }
}

::v-deep .el-dialog__footer {
    // 弹窗底部按钮区
    border-top: 1px solid #4a5568;
    padding: 15px 20px;
    text-align: right;

    .el-button {

        // 取消按钮
        &:first-child {
            background-color: #334155;
            border-color: #475569;
            color: #e2e8f0;

            &:hover {
                background-color: #475569;
                border-color: #64748b;
            }
        }

        // 保存按钮（主按钮）
        &.el-button--primary {
            background-color: #38bdf8;
            border-color: #38bdf8;

            &:hover {
                background-color: #0ea5e9;
                border-color: #0ea5e9;
            }

            &.is-loading {
                background-color: #0284c7;
                border-color: #0284c7;
            }
        }
    }
}

// 弹窗遮罩层样式
::v-deep .el-dialog__wrapper {
    background-color: rgba(0, 0, 0, 0.5);
}
</style>